import { useEffect, useState } from "react";

export const defaultDebounceIntervalMs = 300;

export default function useDebounce<T>(value: T, delay: number = defaultDebounceIntervalMs) {
	const [debouncedValue, setDebouncedValue] = useState(value);
	useEffect(() => {
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}
